import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { tokenRefresh } from '../../common/api';
import { map, publishReplay, shareReplay, refCount, delay } from 'rxjs/operators';

@Injectable()
export class HttpService {

  constructor(
    public url: string,
    public http: HttpClient
  ) { }

  get(customUrl?) {
    const url = customUrl ? customUrl : this.url;

    return this.http.get(url).catch(this.handleErrorCatch);
  }

  getAll() {
    return this.http.get(this.url).catch(this.handleErrorCatch);
  }

  post(payload: any) {
    return this.http.post(this.url, payload).catch(this.handleErrorCatch);
  }

  delete(payload: any) {
    return this.http.delete(this.url).catch(this.handleErrorCatch);
  }

  put(payload: any) {
    return this.http.put(this.url, payload).catch(this.handleErrorCatch);
  }

  private handleErrorCatch(error: Response) {
    return Observable.throw(error);
  }

  refreshToken() {
    let user = JSON.parse(localStorage.getItem('cashUser'));
    let token = localStorage.getItem('token');
    let data = {
      refresh_token: (user.refresh_token)? user.refresh_token : token
    }
    // this.getRefreshToken(data).subscribe(res=>{
    //   user.token = res.access_token;
    //   user.refresh_token = res.refresh_token;
    //   localStorage.setItem('cashUser', JSON.stringify(user));
    //   localStorage.setItem('token', res.access_token);
    // });
   }


  private getRefreshToken(data){
    return this.http.post(tokenRefresh, data).map(res => {
      // localStorage.setItem('token', res['data'].token);
      return res['data'];
    });
  }  

}
